import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { organization } from './queryKeys';
import envVars from '../../../constants/envVars';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
const useGetOrganization = (params, enabled) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(`${envVars.API_COMMERCE_HOSTNAME}organizations/backoffice/organization/`, {
            ...additional,
            params
        }),
        queryKey: [organization, params.id],
        enabled
    });
};
export default useGetOrganization;
